import { Component } from '@angular/core';
import { Http } from '@angular/http';

export interface DownloadUser {
  firstname: string;
  lastname: string;
  email: string;
  organization: string;
  country: string;
}

@Component({
  selector: 'amber-download-form',
  template: require('./amber-download-form.component.html'),
  styles: [require('./amber-download-form.component.scss')]
})
export class AmberDownloadFormComponent {

  downloadUser: DownloadUser = {
    firstname: null,
    lastname: null,
    email: null,
    organization: null,
    country: null
  };

  constructor(private http: Http) { }

  onSubmit($event: any) {
    console.log('HERE?!', $event, this.downloadUser);
    const cloudFn = 'https://europe-west1-amber-barrier-tracker.cloudfunctions.net/atlas-download-subscribe';

    this.http.post(cloudFn, this.downloadUser).toPromise().then(result => {
      console.log('RESULT!', result);
      localStorage.setItem('amber-download-cookie', 'true');
      const event = new CustomEvent('downloadSubscribe', {
        detail: this.downloadUser
      });
      document.body.dispatchEvent(event);
    });


  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/amber-download-form/amber-download-form.component.ts